import * as _ from 'lodash'


class ASync {

  static resolve(obj?: any): Promise<any> {
    return new Promise<any>((r, e) => {
      r(obj)
    })
  }

  static error(error: any): Promise<any> {
    return new Promise<any>((r, e) => {
      e(error)
    })
  }

  static pollWait(conditionFunction: () => boolean, timeSeconds: number, maxWaitTimeSeconds: number): Promise<void> {

    if(!_.isFunction(conditionFunction)){ return ASync.error("Condition Function isn't function")}

    return new Promise<void>((resolve, error) => {
      if(maxWaitTimeSeconds < 0){
        error("max wait time exceeded")
        return
      }

      // Recheck Condition
      if(conditionFunction()){
        resolve()
      } else {
        setTimeout(()=> {
          ASync.pollWait(conditionFunction, timeSeconds, maxWaitTimeSeconds - timeSeconds)
              .then((ignore: void)=> {
                resolve()
              })
              .catch((err) => {
                error(err)
              })
        }, timeSeconds * 1000)
      }

    })
  }

}
//declare function isPromise<T, S>(obj: PromiseLike<T> | S): obj is PromiseLike<T>;
function isPromise<T, S>(obj: PromiseLike<T> | S): obj is PromiseLike<T> {
  // @ts-ignore
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}

export {ASync, isPromise }
